import React, { SetStateAction, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Box, Snackbar, Table, TableBody, TableCell, TableRow, Typography, } from "@mui/material";
import { TableContainer } from "@mui/material";
import { Paper, Stack } from "@mui/material";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";

import { ICabecalhoEP } from "../../../Interfaces/cadernos/caderno11";
import { CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../Components/Popover";
import { TableHead } from "@mui/material";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { StyledTableCellCabecalho } from "../../../Styles/tabelCellStyled/customTableCell";
import { desformatarNumero_return_null, formatarNumero_ao_digitar, desformatarNumero } from "../../../Func_genericas/formatar_numero_formato_pt";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { Alert } from "../../../Components/Alert/Alert";
import { formatar_numeros_Cabecalho_11 } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/cadernos11";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";


interface ICabecalhoFormProps {
  cabecalhos: ICabecalhoEP[];
  setCabecalhos: React.Dispatch<SetStateAction<ICabecalhoEP[]>>;
  obj_Cabecalho: ICabecalhoEP | undefined;
  set_obj_Cabecalho: React.Dispatch<SetStateAction<ICabecalhoEP | undefined>>;
}

export const CabecalhoEPForm: React.FC<ICabecalhoFormProps> = ({
  cabecalhos,
  setCabecalhos,
  obj_Cabecalho,
  set_obj_Cabecalho,
}) => {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = React.useState("");
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);

  const [createcabecalho, setCreateCabecalho] = useState(false);
  const [open_delete, set_open_delete] = useState(false);

  const [error_fossas, setError_fossas] = useState<boolean>(false);
  const [error_nitreiras, set_error_nitreiras] = useState<boolean>(false);
  const [error_valas_condu_fluentes, set_error_valas_condu_fluentes] = useState<boolean>(false);
  const [error_n_lagos_imperm, set_error_lagos_imperm] = useState<boolean>(false);
  const [error_outros_reservatorios, set_error_outros_reservatorios] = useState<boolean>(false);
  const [error_contratualizada, set_error_contratualizada] = useState<boolean>(false);
  const message_apenas_numero = ("Apenas números são aceites");

  const camposNumericos = ["fossas", "nitreiras", "valas_condu_fluentes", "lagos_imperm", "outros_reservatorios", "contratualizada"];
  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handleCancel()


    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };
  async function getTabela() {
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_gest_fluentes_onze_um_rosto/${location.state.id_rosto}`);

      if (res.status === 200) {
        if (res.data.result[0].id_fluentes_um) {

          const formattedData = res.data.result.map(formatar_numeros_Cabecalho_11);
          setCabecalhos(formattedData);
          // set_obj_Cabecalho((prevNewRow: any) => ({
          //   ...prevNewRow,
          //   id_fluentes_um: res.data.result[0].id_fluentes_um
          // }));
        }
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getCabecalhoOperaCulturais", error, true);
      setIsLoading(false);
    }
  }
  useEffect(() => {
    (async () => {
      await getTabela();
    })();
  }, []);

  const onInputChange = (event: any) => {
    const { name, value, type } = event.target;

    let aux_obj_checked: any = obj_Cabecalho === undefined ? {} : obj_Cabecalho
    set_flag_editado(true)
    if (type === "checkbox") {

      aux_obj_checked[name] = aux_obj_checked[name] === undefined ? true : !aux_obj_checked[name]
      set_obj_Cabecalho((prev: any) => ({
        ...prev,
        [name]: aux_obj_checked[name] === undefined ? false : aux_obj_checked[name],
      }));

    } else {
      const isCampoNumerico = camposNumericos.includes(name);

      if (isCampoNumerico) {
        const valorSemFormatar = value.replace(/[^\d,]/g, "");
        const valorNumerico = parseFloat(value.replace(",", "."));

        if (!isNaN(valorNumerico)) {

          if (name === "fossas") {
            setError_fossas(false);
          } else if (name === "nitreiras") {
            set_error_nitreiras(false);
          } else if (name === "valas_condu_fluentes") {
            set_error_valas_condu_fluentes(false);
          } else if (name === "lagos_imperm") {
            set_error_lagos_imperm(false);
          } else if (name === "outros_reservatorios") {
            set_error_outros_reservatorios(false);
          } else if (name === "contratualizada") {
            set_error_contratualizada(false);
          }
        } else {
          if (name === "fossas") {
            setError_fossas(true);
          } else if (name === "nitreiras") {
            set_error_nitreiras(true);
          } else if (name === "valas_condu_fluentes") {
            set_error_valas_condu_fluentes(true);
          } else if (name === "lagos_imperm") {
            set_error_lagos_imperm(true);
          } else if (name === "outros_reservatorios") {
            set_error_outros_reservatorios(true);
          } else if (name === "contratualizada") {
            set_error_contratualizada(true);
          }
        }
        set_obj_Cabecalho((prev: any) => ({
          ...prev,
          [name]: formatarNumero_ao_digitar(valorSemFormatar),
        }));
      } else {
        set_obj_Cabecalho((prev: any) => ({
          ...prev,
          [name]: value,
        }));
      }
    }
  };

  const handleSaveNewCabecalho = async () => {


    try {
      setIsLoading(true);
      let res = await post(auth.token.cookie_token, "/new_reg_gest_fluentes_onze_um", {
        payload: {
          id_fluentes_um: 0,
          fossas: obj_Cabecalho?.fossas === undefined ? null : desformatarNumero(obj_Cabecalho.fossas),
          nitreiras: obj_Cabecalho?.nitreiras === undefined ? null : desformatarNumero(obj_Cabecalho.nitreiras),
          valas_condu_fluentes: obj_Cabecalho?.valas_condu_fluentes === undefined ? null : desformatarNumero(obj_Cabecalho.valas_condu_fluentes),
          lagos_imperm: obj_Cabecalho?.lagos_imperm === undefined ? null : desformatarNumero(obj_Cabecalho.lagos_imperm),
          outros_reservatorios: obj_Cabecalho?.outros_reservatorios === undefined ? null : desformatarNumero(obj_Cabecalho.outros_reservatorios),
          contratualizada: obj_Cabecalho?.contratualizada === undefined ? null : desformatarNumero(obj_Cabecalho.contratualizada),
          id_rosto: location.state.id_rosto,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });

      if (res.status === 200) {
        setMessage("Gravado com sucesso!");
        setOpenSnackSuccess(true);
        setCreateCabecalho(false);
        set_flag_editado(false)
        setCabecalhos((prevRows) => [
          ...prevRows,
          formatar_numeros_Cabecalho_11(res.data.result),
        ])
        set_obj_Cabecalho(undefined)
        set_error_contratualizada(false);
        set_error_lagos_imperm(false);
        set_error_nitreiras(false);
        set_error_outros_reservatorios(false);
        set_error_valas_condu_fluentes(false);
        setError_fossas(false);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      func_print("handleSaveNewCabecalho", error, true);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setOpenSnackError(true);
      setIsLoading(false);
    }

  };
  // Editar
  const handleEdit = (obj: ICabecalhoEP) => {
    set_obj_Cabecalho(obj)
    setCreateCabecalho(false);
  };

  const handleCancel = () => {
    setCreateCabecalho(false);
    set_obj_Cabecalho(undefined);
    set_error_contratualizada(false);
    set_error_lagos_imperm(false);
    set_error_nitreiras(false);
    set_error_outros_reservatorios(false);
    set_error_valas_condu_fluentes(false);
    setError_fossas(false);
  }


  const handleUpdateCabecalho = async () => {

    try {
      setIsLoading(true);
      let res = await post(auth.token.cookie_token, "update_reg_gest_fluentes_onze_um", {
        payload:
        {
          id_fluentes_um: obj_Cabecalho?.id_fluentes_um,
          fossas: obj_Cabecalho?.fossas === undefined ? "" : desformatarNumero_return_null(obj_Cabecalho?.fossas),
          nitreiras: obj_Cabecalho?.nitreiras === undefined ? "" : desformatarNumero_return_null(obj_Cabecalho?.nitreiras),
          valas_condu_fluentes: obj_Cabecalho?.valas_condu_fluentes === undefined ? "" : desformatarNumero_return_null(obj_Cabecalho?.valas_condu_fluentes),
          lagos_imperm: obj_Cabecalho?.lagos_imperm === undefined ? "" : desformatarNumero_return_null(obj_Cabecalho?.lagos_imperm),
          outros_reservatorios: obj_Cabecalho?.outros_reservatorios === undefined ? "" : desformatarNumero_return_null(obj_Cabecalho?.outros_reservatorios),
          contratualizada: obj_Cabecalho?.contratualizada === undefined ? "" : desformatarNumero_return_null(obj_Cabecalho?.contratualizada),
          id_rosto: obj_Cabecalho?.id_rosto,
          last_update: obj_Cabecalho?.last_update,
          create_date: obj_Cabecalho?.create_date,
          uuid: "",
        }
      })

      if (res.status === 200) {
        const updatedRows =
          cabecalhos.map((cab) => {
            if (cab.id_fluentes_um !==
              obj_Cabecalho?.id_fluentes_um) {
              return cab
            } else {
              return formatar_numeros_Cabecalho_11(res.data.result)
            }
          }
          );
        setCabecalhos(updatedRows);
        set_obj_Cabecalho(undefined)
        set_flag_editado(false)

        setMessage("Registo atualizado com sucesso!");
        setOpenSnackSuccess(true);
        set_error_contratualizada(false);
        set_error_lagos_imperm(false);
        set_error_nitreiras(false);
        set_error_outros_reservatorios(false);
        set_error_valas_condu_fluentes(false);
        setError_fossas(false);
      } else {
        setMessage("Erro ao atualizar o cabeçalho!");
        setOpenSnackError(true);
      }
      setIsLoading(false);

    } catch (error) {
      func_print("handleUpdateCabecalho", error, true);
      setMessage("Erro ao atualizar o cabeçalho!");
      setOpenSnackError(true);
      setIsLoading(false);
    }


  };

  // Delete
  const handleClickOpenDelete = (obj: ICabecalhoEP) => {
    set_obj_Cabecalho(obj)
    set_open_delete(true);
  };
  const handle_delete_cabecalho = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete_gest_fluentes_onze_um/${obj_Cabecalho?.id_fluentes_um}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        set_open_delete(false);
        setCabecalhos((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_fluentes_um !== obj_Cabecalho?.id_fluentes_um),
        ]);
        set_obj_Cabecalho(undefined)
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  return (
    <form>
      <CustomThemeProvider>
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCellCabecalho
                  colSpan={2}
                  sx={{ fontWeight: 700, fontSize: 18, fontFamily: "candara" }} >
                  11 - Registo de gestão de efluentes pecuários
                  <BasicPopover
                    text={"O Registo da gestão de efluentes pecuários, no caso de o beneficiário assim o desejar, pode ser utilizado para cumprimento da Portaria n.º 259/2012 (Anexo XI), de 28 de agosto e para cumprimento, em parte (apoio à verificação dos indicadores 2.1 e 2.2), ao indicador 2 do RLG 2 da Portaria n.º 54-Q/2023, de 27 de fevereiro."} />
                </StyledTableCellCabecalho>
              </TableRow>
            </TableHead>
            <TableBody>
              {cabecalhos.length === 0 &&
                (createcabecalho === false ? (
                  <>
                    <TableRow>
                      <StyledTableCellCabecalho
                        sx={{ fontWeight: 600, fontSize: 16, fontFamily: "candara" }}
                      >
                        1 - Capacidade das infraestruturas de armazenamento da
                        exploração agrícola
                      </StyledTableCellCabecalho>

                      <TableCell>
                        <Stack direction="row" sx={{ justifyContent: "end" }}>
                          {is_historico === true ? <></> :

                            <BarraDeFerramentas
                              mostrarBotaoNovo
                              textoBotaoNovo="Registar"
                              aoClicarNovo={() => {
                                set_obj_Cabecalho(undefined)
                                setCreateCabecalho(true)
                              }}
                            />}
                        </Stack>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Fossas: ______ m3
                        </Stack>
                      </StyledTableCellCabecalho>

                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Nitreiras: ___ m3
                        </Stack>
                      </StyledTableCellCabecalho>
                    </TableRow>
                    <TableRow>
                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Valas de condução de efluentes: ____ m3
                        </Stack>
                      </StyledTableCellCabecalho>
                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Lagoas impermeáveis: ___ m3
                        </Stack>
                      </StyledTableCellCabecalho>
                    </TableRow>
                    <TableRow>
                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Outros resertatórios:___ m3
                        </Stack>
                      </StyledTableCellCabecalho>
                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Contratualizada: ___ m3
                        </Stack>
                      </StyledTableCellCabecalho>
                    </TableRow>
                  </>
                ) : (
                  <>
                    <TableRow>
                      <StyledTableCellCabecalho
                        sx={{
                          fontWeight: 600,
                          textAlign: "left",
                          fontFamily: "candara",
                          fontSize: 16,
                        }}
                      >
                        1 - Capacidade das infraestruturas de armazenamento da
                        exploração agrícola
                      </StyledTableCellCabecalho>
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "end",
                            fontFamily: "candara",
                          }}
                        >
                          <ButtonCadernos
                            mostrarBotaoGravar
                            aoClicarGravar={handleSaveNewCabecalho}
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {
                                handleCancel()
                              }
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Fossas:
                          <CustomTextField
                            name="fossas"
                            value={obj_Cabecalho?.fossas === undefined ? "" : obj_Cabecalho.fossas}
                            onChange={onInputChange}
                            error={error_fossas}
                            helperText={error_fossas ? message_apenas_numero : ""}
                          />
                          m3
                        </Stack>
                      </StyledTableCellCabecalho>

                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Nitreiras:
                          <CustomTextField
                            name="nitreiras"
                            value={obj_Cabecalho?.nitreiras === undefined ? "" : obj_Cabecalho.nitreiras}
                            onChange={onInputChange}
                            error={error_nitreiras}
                            helperText={error_nitreiras ? message_apenas_numero : ""} />
                          m3
                        </Stack>
                      </StyledTableCellCabecalho>
                    </TableRow>
                    <TableRow>
                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Valas de condução de efluentes:
                          <CustomTextField
                            name="valas_condu_fluentes"
                            value={obj_Cabecalho?.valas_condu_fluentes === undefined ? "" : obj_Cabecalho.valas_condu_fluentes}
                            onChange={onInputChange}
                            error={error_valas_condu_fluentes}
                            helperText={error_valas_condu_fluentes ? message_apenas_numero : ""} />
                          m3
                        </Stack>
                      </StyledTableCellCabecalho>
                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Lagoas impermeáveis:
                          <CustomTextField
                            name="lagos_imperm"
                            value={obj_Cabecalho?.lagos_imperm === undefined ? "" : obj_Cabecalho.lagos_imperm}
                            onChange={onInputChange}
                            error={error_n_lagos_imperm}
                            helperText={error_n_lagos_imperm ? message_apenas_numero : ""} />
                          m3
                        </Stack>
                      </StyledTableCellCabecalho>
                    </TableRow>
                    <TableRow>
                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Outros resertatórios:
                          <CustomTextField
                            name="outros_reservatorios"
                            value={obj_Cabecalho?.outros_reservatorios === undefined ? "" : obj_Cabecalho.outros_reservatorios}
                            onChange={onInputChange}
                            error={error_outros_reservatorios}
                            helperText={error_outros_reservatorios ? message_apenas_numero : ""} />
                          m3
                        </Stack>
                      </StyledTableCellCabecalho>
                      <StyledTableCellCabecalho>
                        <Stack direction="row" alignItems="center">
                          Contratualizada:
                          <CustomTextField
                            name="contratualizada"
                            value={obj_Cabecalho?.contratualizada === undefined ? "" : obj_Cabecalho.contratualizada}
                            onChange={onInputChange}
                            error={error_contratualizada}
                            helperText={error_contratualizada ? message_apenas_numero : ""} />
                          m3
                        </Stack>
                      </StyledTableCellCabecalho>
                    </TableRow>
                  </>
                ))}
            </TableBody>
            <TableBody>
              {cabecalhos.length > 0 &&
                cabecalhos.map((cab, key) => (
                  <React.Fragment key={key}>
                    {obj_Cabecalho?.id_fluentes_um === cab.id_fluentes_um ? (
                      <>
                        <TableRow>
                          <StyledTableCellCabecalho
                            sx={{
                              fontWeight: 600,
                              textAlign: "left",
                              fontFamily: "candara",
                              fontSize: 16,
                            }}
                          >
                            1 - Capacidade das infraestruturas de armazenamento
                            da exploração agrícola
                          </StyledTableCellCabecalho>
                          <StyledTableCellCabecalho>
                            <Stack
                              direction="row"
                              sx={{ justifyContent: "end" }}
                            >
                              <ButtonCadernos
                                mostrarBotaoGravar
                                aoClicarGravar={handleUpdateCabecalho}
                                mostrarBotaoCancelar
                                aoClicarCancelar={() => {
                                  if (flag_editado) {
                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                  } else {
                                    handleCancel()
                                  }
                                }}
                              />
                            </Stack>
                          </StyledTableCellCabecalho>
                        </TableRow>
                        <TableRow>
                          <StyledTableCellCabecalho colSpan={2}>
                            1 - Capacidade das infraestruturas de armazenamento
                            da exploração agrícola
                          </StyledTableCellCabecalho>
                        </TableRow>
                        <TableRow>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              <BasicPopover
                                text="m3 refere-se à unidade de capacidade do chorume."
                              />
                              Fossas:
                              <CustomTextField
                                name="fossas"
                                value={obj_Cabecalho?.fossas}
                                onChange={onInputChange}
                                error={error_fossas}
                                helperText={error_fossas ? message_apenas_numero : ""} />
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>

                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              Nitreiras:
                              <CustomTextField
                                name="nitreiras"
                                value={obj_Cabecalho?.nitreiras}
                                onChange={onInputChange}
                                error={error_nitreiras}
                                helperText={error_nitreiras ? message_apenas_numero : ""} />
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                        </TableRow>
                        <TableRow>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              Valas de condução de efluentes:
                              <CustomTextField
                                name="valas_condu_fluentes"
                                value={obj_Cabecalho?.valas_condu_fluentes}
                                onChange={onInputChange}
                                error={error_valas_condu_fluentes}
                                helperText={error_valas_condu_fluentes ? message_apenas_numero : ""} />
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              Lagoas impermeáveis:
                              <CustomTextField
                                name="lagos_imperm"
                                value={obj_Cabecalho?.lagos_imperm}
                                onChange={onInputChange}
                                error={error_n_lagos_imperm}
                                helperText={error_n_lagos_imperm ? message_apenas_numero : ""} />
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                        </TableRow>
                        <TableRow>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              Outros resertatórios:
                              <CustomTextField
                                name="outros_reservatorios"
                                value={obj_Cabecalho?.outros_reservatorios}
                                onChange={onInputChange}
                                error={error_outros_reservatorios}
                                helperText={error_outros_reservatorios ? message_apenas_numero : ""} />
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              Contratualizada:
                              <CustomTextField
                                name="contratualizada"
                                value={obj_Cabecalho?.contratualizada}
                                onChange={onInputChange}
                                error={error_contratualizada}
                                helperText={error_contratualizada ? message_apenas_numero : ""} />
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                        </TableRow>
                      </>
                    ) : (
                      <>
                        <TableRow>
                          <StyledTableCellCabecalho >
                            1 - Capacidade das infraestruturas de armazenamento
                            da exploração agrícola
                          </StyledTableCellCabecalho>
                          <StyledTableCellCabecalho colSpan={2}>
                            <Stack direction="row" justifyContent="end"  >
                              {is_historico === true ? <></> :

                                <ButtonCadernos
                                  mostrarBotaoEditar
                                  aoClicarEditar={() => handleEdit(cab)}
                                  mostrarBotaoApagar
                                  aoClicarApagar={() => handleClickOpenDelete(cab)}
                                />}
                            </Stack>
                          </StyledTableCellCabecalho>
                        </TableRow>
                        <TableRow>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              <BasicPopover
                                text="m3 refere-se à unidade de capacidade do chorume."
                              />
                              Fossas:
                              <Typography
                                style={{
                                  fontFamily: "verdana",
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  fontSize: 14,
                                }}
                              >
                                {cab.fossas}
                              </Typography>
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              Nitreiras:
                              <Typography
                                style={{
                                  fontFamily: "verdana",
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  fontSize: 14,
                                }}
                              >
                                {cab.nitreiras}
                              </Typography>
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                        </TableRow>
                        <TableRow>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              Valas de condução de efluentes:
                              <Typography
                                style={{
                                  fontFamily: "verdana",
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  fontSize: 14,
                                }}
                              >
                                {cab.valas_condu_fluentes}
                              </Typography>
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              Lagoas impermeáveis:
                              <Typography
                                style={{
                                  fontFamily: "verdana",
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  fontSize: 14,
                                }}
                              >
                                {cab.lagos_imperm}
                              </Typography>
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                        </TableRow>
                        <TableRow>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              Outros resertatórios:
                              <Typography
                                style={{
                                  fontFamily: "verdana",
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  fontSize: 14,
                                }}
                              >
                                {cab.outros_reservatorios}
                              </Typography>
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                          <StyledTableCellCabecalho>
                            <Stack direction="row" alignItems="center">
                              Contratualizada:
                              <Typography
                                style={{
                                  fontFamily: "verdana",
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  fontSize: 14,
                                }}
                              >
                                {cab.contratualizada}
                              </Typography>
                              m3
                            </Stack>
                          </StyledTableCellCabecalho>
                        </TableRow>
                      </>
                    )}
                  </React.Fragment>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <ConfirmDialog
          open={open_delete}
          onClose={() => set_open_delete(false)}
          onConfirm={handle_delete_cabecalho}
          message="Deseja eliminar o registo?"
        />
        <ConfirmDialog
          open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
          onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
          onConfirm={() => handleCloseDialog()}
          message={mensagem_tem_a_certeza_de_apagar_alteracoes}
        />
      </CustomThemeProvider>
    </form>
  );
};
